<template>
  <div class="activity" v-if="data.style" :style="'position: relative;background-image:url('+oss+data.style.backgroundImage+');background-color:'+data.style.backgroundColor">
    <div class="top_btn">
      <div>活动细则</div>
      <div v-if="data.params.is_show_user">会员中心</div>
    </div>
    <div class="dm">
      <img src="@/assets/images/headuser.png" alt="">
      <p> #滚**机# 抽中 微信红包10元</p>
    </div>
    <div class="join_btn" :style="'background-image:url('+oss+data.style.btnBackgroundImage+')'"></div>
    <div class="link" v-if="data.params.is_show_guide">导购激活</div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.activity {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  .top_btn {
    position: absolute;
    right: 12px;
    top: 21px;
    > div {
      width:80px;
      height: 24px;
      background: rgba(250, 250, 250, 0.6);
      border-radius: 12px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #af1817;
      text-align: center;
      line-height: 24px;
      margin-bottom: 5px;
    }
  }
  .dm {
    position: absolute;
    bottom: 150px;
    width: 211px;
    height: 30px;
    border-radius: 0px 15px 15px 0px;
    background-color: rgba(250, 250, 250, 0.6);
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #af1817;
    padding-left: 14px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .join_btn {
    position: absolute;
    bottom: 30px;
    width: 168px;
    height: 64px;
    left: 50%;
    transform: translateX(-50%);
    background-size: cover;
  }
  .link{
    position:absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    color:#fff ;
    text-decoration: underline;
  }
}
</style>